import React from 'react';
import { InvoiceStatus } from '@css-xp/graphtypes/src/generated-types-new';
import { FormatCurrency, NoData } from '@css-xp/ppc-common';
import { getInvoiceStatus } from '@css-xp/ppc-invoice-table';

export const getTermDetailsInvoiceStatus = (status: string | undefined | null) => {
  if (!status) return <NoData />;
  if (status === InvoiceStatus.PAYMENT_DEFERRED) {
    status = InvoiceStatus.PAID;
  }
  // if (status === InvoiceStatus.OPEN) {
  //   status = InvoiceStatus.PAYMENT_DEFERRED;
  // }
  return getInvoiceStatus(status);
};

export const getTermDetailsInvoiceAmount = (
  grandTotal: string | number,
  paymentCurrency: string | undefined | null
) => {
  return (
    <td>
      {grandTotal ? (
        <FormatCurrency value={grandTotal} currency={paymentCurrency} showCurrencyCode showCommas />
      ) : (
        <NoData />
      )}
    </td>
  );
};
